import { useCommunityCountsContext } from '~publish/contexts/CommunityCountsContext'

import { useMobileSidebar } from './MobileSidebarContext'
import { MobileTopbarShell } from './MobileTopbarShell'
import { Logo } from '../Logo/Logo'
import { StreaksWidget } from '../Streaks/StreaksWidget'

import type { JSX } from 'react'

export function MobileTopbar(): JSX.Element {
  const { navigationOpen, setNavigationOpen } = useMobileSidebar()
  const { totalOrgCount: commentsCount, loading: commentsLoading } =
    useCommunityCountsContext()

  const showBadge = !navigationOpen && commentsCount > 0 && !commentsLoading

  return (
    <MobileTopbarShell
      navigationOpen={navigationOpen}
      onNavigationOpenChange={setNavigationOpen}
      logo={<Logo />}
      rightContent={<StreaksWidget />}
      showBadge={showBadge}
      openMenuBadgeLabel={`Open menu, ${commentsCount} unreplied comments`}
    />
  )
}
